// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1Ec7c","inputWrap":"CustomTip_inputWrap__2Qc5r"};